import React from 'react';
import { CalendarDays, CalendarRange, Clock } from 'lucide-react';
import { SessionCard } from './SessionCard';
import type { WebinarGroup } from '../../data/webinars';
import { isPastSession } from '../../utils/webinars';
type CoreWebinarProps = {
  group: WebinarGroup;
  nextSessionId?: string;
};
export function CoreWebinar({
  group,
  nextSessionId
}: CoreWebinarProps) {
  const {
    eyebrow,
    title,
    description,
    schedule,
    sessions
  } = group;
  return <section aria-labelledby="core-webinar-heading" className="w-full bg-white py-24 sm:py-28 lg:py-[120px]" data-id="element-5" data-mp="2soe3xa4p4vka">
      <div className="mx-auto w-full max-w-[1280px] px-6 sm:px-10" data-id="element-6" data-mp="2jtzi0opnums7">
        <header data-id="element-7" data-mp="2jtr3ksdw39ew">
          <p className="text-[15px] font-semibold uppercase tracking-[0.14em] text-brand" data-id="element-8" data-mp="2js6f9ki64mph">
            {eyebrow}
          </p>
          <h2 id="core-webinar-heading" className="mt-5 max-w-[900px] font-heading text-[32px] font-bold leading-[1.15] tracking-tight text-ink sm:text-[38px] lg:text-[44px]" data-id="element-9" data-mp="3bkndbk4nkxxy">
            {title}
          </h2>
          <p className="mt-6 max-w-[650px] text-lg leading-[1.7] text-body" data-id="element-10" data-mp="31qtpwv66o96t">
            {description}
          </p>

          {schedule && <dl className="mt-8 flex flex-wrap gap-3" data-id="element-11" data-mp="3bg3kchoi23y3">
              <div className="flex items-center gap-2.5 rounded-full bg-tint px-5 py-2.5" data-id="element-12" data-mp="3bhock0ncdass">
                <CalendarDays className="h-[18px] w-[18px] shrink-0 text-brand" aria-hidden="true" data-id="element-13" data-mp="36o264q7ru35f" />
                <dt className="sr-only" data-id="element-14" data-mp="3gfzl881whf9f">Frequency</dt>
                <dd className="text-[15px] font-medium text-ink" data-id="element-15" data-mp="3gf6kbnpmhjz7">
                  {schedule.days}
                </dd>
              </div>
              <div className="flex items-center gap-2.5 rounded-full bg-tint px-5 py-2.5" data-id="element-16" data-mp="3pgeblltq1kjs">
                <Clock className="h-[18px] w-[18px] shrink-0 text-brand" aria-hidden="true" data-id="element-17" data-mp="200ybsx1otb6k" />
                <dt className="sr-only" data-id="element-18" data-mp="1v3evzspccqci">Time</dt>
                <dd className="text-[15px] font-medium text-ink" data-id="element-19" data-mp="3v4cxx4bssyyj">
                  {schedule.time}
                </dd>
              </div>
              <div className="flex items-center gap-2.5 rounded-full bg-tint px-5 py-2.5" data-id="element-20" data-mp="3yuy5tmz9vhy">
                <CalendarRange className="h-[18px] w-[18px] shrink-0 text-brand" aria-hidden="true" data-id="element-21" data-mp="7ylvyhax9bvz" />
                <dt className="sr-only" data-id="element-22" data-mp="cwdq7hz1ha3c">Dates</dt>
                <dd className="text-[15px] font-medium text-ink" data-id="element-23" data-mp="hwrucoxirzw3">
                  {schedule.dateRange}
                </dd>
              </div>
            </dl>}
        </header>

        <ul className="mt-14 grid grid-cols-1 gap-7 sm:grid-cols-2 lg:mt-16 lg:grid-cols-3 lg:gap-8" data-id="element-24" data-mp="rne96gxewmdq">
          {sessions.map(session => <li key={session.id} className="flex" data-id="element-25" data-mp="vrc4shnj3f21">
              <SessionCard session={session} isNext={session.id === nextSessionId} isPast={isPastSession(session)} data-id="element-26" data-mp="10p3z1ibnbd9e" />
            </li>)}
        </ul>
      </div>
    </section>;
}